<div *ngIf="isStoryCreationMode" class="modal fade" tabindex="-1" role="dialog"
  [config]="{ show: true, backdrop: 'static' }" (onHidden)="onClose()" bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-xl modal-dialog-scrollable h-100 w-100" [ngClass]="{'template-repost-modal': templateRepost === true}">
    <div class="modal-content h-100">
      <div class="modal-header d-flex justify-content-between py-0 border-0 mt-3 pr-3 pl-4">
        <h6 class="heading-3">{{mls.languageText?.stories_creation.key1}}</h6>
        <img class="cursor-pointer" src="assets/images/cross.svg" alt="cross" width="24" height="24"
          (click)="onHidden()" style="width: 24px;">
      </div>
      <div class="modal-body mt-0 row">
        <div class="d-none d-md-block col-4 h-100 p-2"   *ngIf="!templateRepost">
          <div class="editor-height" [ngClass]="{'disable-div': storyUploadProgress === true}">
            <div class="mb-3" *ngIf="showCreationTexting" [hidden]="showTagOnWeb || storyType == STORY_TYPES.TEMPLATE">
              <app-creation-texting   [formType]="storyCreationTextType.WEB" [preText]="storyText"
                [typingLabel]="mls.languageText?.stories_creation.key27" (emitTextOnFocus)="onTextFocus()"
                [typingPlaceholder]="mls.languageText?.stories_creation.key6" (onTypingComplete)="storyText = $event">
              </app-creation-texting>
            </div>
            <div class="mb-3 block" [ngClass]="{'block': customTemplateType === templateType.TEMPLATE}" *ngIf="isCustomTemplate" [hidden]="showTagOnWeb">
              <!-- For the Background on web -->
              <app-custom-template *ngIf="customTemplateType === templateType.BACKGROUND" [templates]="backGroundCode"  [headingText]="mls.languageText?.stories_creation.key2"
                [customType]="templateType.BACKGROUND" (emitSelectTemplate)="selectTemplate($event)">
              </app-custom-template>
              <!-- For the Custom template on web-->
              <app-custom-template *ngIf="customTemplateType === templateType.TEMPLATE" [defaultTemplateCode]="repostingFileCode"  (emitBackGroundTemplate)="changeTemplate($event)" [templates]="templateList" [headingText]="mls.languageText?.stories_creation.key3"
                [customType]="templateType.TEMPLATE" (emitSelectTemplate)="selectTemplate($event)">
              </app-custom-template>
            </div>
            <div class ="mb-3" [ngClass]="{'h-100': showTagOnWeb}" *ngIf="storyType != STORY_TYPES.TEMPLATE">
              <app-tag-user [errorMsg]="mls.languageText.stories_creation.key26" [headingText]="mls.languageText.stories_creation.key9" [noResultText]="mls.languageText.stories_creation.Key15"  [listOffset]="tagListOffset" (emitOnClear)="clearSearch()" (onfocusTag)="showTagFunctionality(true)" [selectedList]="storyServ.storyTagList" [showUserList] = "showUserList" (emithidden)="showTagFunctionality($event)" (removeUser)="removeUser($event)" (addUser)="addUser($event)" [userList]="dss.tag_user_list" (listReload)="onScrollSearch($event)"></app-tag-user>
            </div>
            <div>
            </div>
          </div>
          <div *ngIf="!showTagOnWeb">
            <ng-container *ngTemplateOutlet="upload"></ng-container>
          </div>
          <div class="px-3 pb-3" *ngIf="showTagOnWeb" >
            <ng-container *ngTemplateOutlet="doneTagging"></ng-container>
          </div>
        </div>

        <div class="col-12 col-md-8 p-2 h-100" [ngClass]="{'col-md-12': templateRepost === true}"  >
          <div class="story-preview h-100 py-2">
            <div class="mx-auto story-product w-100">
              <div #screen class="rounded position-absolute max-width-100" style="z-index:-2;">
                <app-user-story-product-card [productType]="productType" [productData]="productData"></app-user-story-product-card>
              </div>
            </div>
            <div class="mx-auto story-console h-100 w-100">
              <div #thumbnailView class="h-100 w-100">
                <app-thumbnail-views (emitRemoveTag)="removeUser($event)" [isTagFeatureInUse]="showTagOnWeb" [isCreationMode]="isStoryCreationMode" [tagUsers]="storyServ.storyTagList"  [productType]="productType" [typingText]="storyText" [storyType]="storyType"
                [isPharmaRepost]="isPharmaRepost"
                [productImage]="storyType === 'PHARMA' || storyType === 'PHARMAREPOST ' ? '' : productImage" [productData]="productData" [backgroundCode]="storyCreateThumbnail?.src" [thumbnail]="storyThumbnail" [backGroundImage]="backGroundImage" noInfoSrc = 'assets/images/unavailable.svg'>
                </app-thumbnail-views>
              <app-creation-texting [ngClass]="{'disable-div': storyUploadProgress === true}" class="d-md-none story-console-texting" *ngIf="isStoryTyping"
                [formType]="storyCreationTextType.M_WEB" [preText]="storyText"
                [typingPlaceholder]="mls.languageText?.stories_creation.key6"
                [buttonText]="mls.languageText?.stories_creation.key7"
                [deletePopupHeading]="mls.languageText?.stories_modal.key5"
                [deletePopupParagraph]="mls.languageText?.stories_modal.key6"
                [deletePopupCancelText]="mls.languageText?.stories_modal.key3"
                [deletePopupDeleteText]="mls.languageText?.stories_modal.key4"
                (onDeleteTyping)="isStoryTyping = false; storyText = ''" (onCancelTyping)="isStoryTyping = false"
                (onTypingComplete)="storyText = $event;isStoryTyping = false;">
              </app-creation-texting>
              </div>
            </div>
            <!-- for background on mweb -->
            <app-creation-options [ngClass]="{'disable-div': storyUploadProgress === true}" *ngIf="!isStoryTyping &&  customTemplateType !==  templateType.TEMPLATE" [customType] = "customTemplateType === templateType.BACKGROUND ? templateType.BACKGROUND : ''" [storyType]="storyType" [backGroundCodes]="backGroundCode" class="d-md-none creation-options"
              [optionsList]="creationOptionsList" (emitBackGroundChange)="selectTemplate($event)"(emitDoAction)="storyOptionAction($event)">
            </app-creation-options>
            <app-custom-template [ngClass]="{'disable-div': storyUploadProgress === true}" *ngIf="isCustomTemplate && customTemplateType ===  templateType.TEMPLATE"  [hidden]="isStoryTyping" class="d-md-none"
            [defaultTemplateCode]="repostingFileCode" (emitBackGroundTemplate)="changeTemplate($event)"  [templates]="templateList" [headingText]="mls.languageText?.stories_creation.key2"
            [customType]="templateType.M_WEB" (emitSelectTemplate)="selectTemplate($event)">
          </app-custom-template>
          </div>
        </div>
      </div>
      <div class="d-md-none px-3 pb-3" [ngClass]="{'d-flex justify-content-center': templateRepost, 'd-md-none': !templateRepost}" *ngIf="!showTagOnWeb" >
        <ng-container *ngTemplateOutlet="upload"></ng-container>
      </div>
    </div>
  </div>
  <ng-template #upload>
    <button  [disabled]="storyUploadProgress || uploadButtonDisabled" class="btn-design medium filled w-100" type="submit" (click)="uploadStory()">
      <span *ngIf="storyUploadProgress" class="spinner-border spinner-border-sm text-light" role="status"
      aria-hidden="true"></span>
      {{mls.languageText?.stories_creation.key4}}
    </button>
  </ng-template>
  <ng-template #doneTagging>
    <button   class="btn-design medium filled w-100"  (click)="showTagFunctionality(false)">
      {{mls.languageText?.stories_creation.key24}}
    </button>
  </ng-template>
    <app-delete-modal [isDeleteModal]="discardStory"  [headingText]="mls.languageText?.stories_creation.key17"
  [paragraphText]="mls.languageText?.stories_creation.key16" [cancelButtonText]="mls.languageText?.stories_creation.key33" [deleteButtonText]="mls.languageText?.stories_creation.key32"
    (emitOnHidden)="discardStory = false"
  (emitOnDelete)="onDiscard()">
</app-delete-modal>
<app-delete-modal [isDeleteModal]="failedUpload"  [headingText]="mls.languageText?.stories_creation.key18"
[paragraphText]="mls.languageText?.stories_creation.key19" [cancelButtonText]="mls.languageText?.stories_creation.key33" [deleteButtonText]="mls.languageText?.stories_creation.key34"
  (emitOnHidden)="failedUpload = false"
(emitOnDelete)="onReupload()">
</app-delete-modal>